type Option = {
  /**
   * linear-gradientで指定する方向 `"45deg"`や`"to top right"`などが有効
   * @default 'to right'
   * @see https://developer.mozilla.org/ja/docs/Web/CSS/gradient/linear-gradient
   */
  angle?: string;
};

export const COLOR_SDGS_DEFAULT = '#cccccc';

export function getSdgsBackground(sdgsNumber: number, option: Option = {}) {
  const angle = option.angle ?? 'to right';
  const { start, end } = sdgs[sdgsNumber] ?? {};

  return `linear-gradient(${angle}, ${start ?? COLOR_SDGS_DEFAULT}, ${end ?? COLOR_SDGS_DEFAULT});`;
}

export type SdgsColor = {
  start: string;
  end: string;
};

const sdgs: Record<number, SdgsColor | undefined> = {
  1: {
    start: '#FFEC5C',
    end: '#DB0015',
  },
  2: {
    start: '#95CEFF',
    end: '#D39400',
  },
  3: {
    start: '#FFAAB8',
    end: '#25862A',
  },
  4: {
    start: '#FFD5D1',
    end: '#B7001E',
  },
  5: {
    start: '#69D6FF',
    end: '#E01F10',
  },
  6: {
    start: '#FFCC60',
    end: '#0098D1',
  },
  7: {
    start: '#D04169',
    end: '#FFAD00',
  },
  8: {
    start: '#FF792F',
    end: '#830025',
  },
  9: {
    start: '#FF6EB6',
    end: '#E85200',
  },
  10: {
    start: '#DDFF6E',
    end: '#CD0468',
  },
  11: {
    start: '#FFF080',
    end: '#F68E00',
  },
  12: {
    start: '#C2FFA0',
    end: '#CD7D00',
  },
  13: {
    start: '#6AC6FF',
    end: '#3D6726',
  },
  14: {
    start: '#ACFF9B',
    end: '#0063AC',
  },
  15: {
    start: '#CAFD56',
    end: '#3A9927',
  },
  16: {
    start: '#739CD1',
    end: '#003D76',
  },
  17: {
    start: '#FFBEC3',
    end: '#002555',
  },
};

export type FilterSdgsColorMap = {
  [key: number]: string;
};
export const filterSdgsColorMap: FilterSdgsColorMap = {
  1: '#E4011E',
  2: '#D6A600',
  3: '#1B973A',
  4: '#C50E28',
  5: '#E83418',
  6: '#00A6D9',
  7: '#FABD00',
  8: '#970A31',
  9: '#EC6A06',
  10: '#DC097B',
  11: '#F5A20B',
  12: '#D39206',
  13: '#407936',
  14: '#0075BA',
  15: '#28A838',
  16: '#004C88',
  17: '#023067',
};

export default sdgs;
